<template>
  <div ref="chart" style="width: 600px; height: 400px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'BarChart',
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartInstance: null
    };
  },
  watch: {
    chartData: {
      handler(newVal) {
        this.initChart(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.initChart(this.chartData);
  },
  methods: {
    initChart(data) {
      if (!data || !data.labels || !data.datasets || data.labels.length === 0) {
        console.warn("数据为空，无法渲染图表");
        return;
      }

      if (!this.chartInstance) {
        this.chartInstance = echarts.init(this.$refs.chart);
      }

      const option = {
        tooltip: {trigger: 'axis'},
        xAxis: {
          type: 'category',
          data: data.labels
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: data.datasets[0].label,
          type: 'bar',
          data: data.datasets[0].data,
          itemStyle: {
            color: '#5470c6'
          }
        }]
      };

      this.chartInstance.setOption(option, true);
    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  }
};
</script>